import { apiProxyRequest } from "Api/apiProxyRequest";

import type { ProjectUsageAlert } from "../types";

export const getProjectUsageAlerts = (
  billingProfileId: string,
  projectId: string
) =>
  apiProxyRequest<ProjectUsageAlert[]>(
    `/billing/profiles/${billingProfileId}/alerts/projects/${projectId}/usage`
  );
